import { render, staticRenderFns } from "./CompactFinancialItem.vue?vue&type=template&id=11945ad9&scoped=true&"
import script from "./CompactFinancialItem.vue?vue&type=script&lang=js&"
export * from "./CompactFinancialItem.vue?vue&type=script&lang=js&"
import style0 from "./CompactFinancialItem.vue?vue&type=style&index=0&id=11945ad9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11945ad9",
  null
  
)

export default component.exports